export default "__VITE_ASSET__0hSwsHMB__"